import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BreadcrumbNavigation = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    {
      label: 'Dashboard',
      path: '/client-dashboard',
      icon: 'LayoutDashboard'
    },
    {
      label: 'Add Client',
      path: '/add-new-client',
      icon: 'UserPlus',
      current: true
    }
  ];

  const handleBreadcrumbClick = (path) => {
    if (path) {
      navigate(path);
    }
  };

  return (
    <nav className="mb-8" aria-label="Breadcrumb">
      <div className="flex items-center space-x-2 text-sm">
        {breadcrumbs.map((breadcrumb, index) => (
          <React.Fragment key={breadcrumb.path}>
            {index > 0 && (
              <Icon 
                name="ChevronRight" 
                size={16} 
                className="text-muted-foreground" 
              />
            )}
            <div className="flex items-center space-x-2">
              <Icon 
                name={breadcrumb.icon} 
                size={16} 
                className={breadcrumb.current ? 'text-primary' : 'text-muted-foreground'} 
              />
              {breadcrumb.current ? (
                <span className="font-medium text-foreground">
                  {breadcrumb.label}
                </span>
              ) : (
                <button
                  onClick={() => handleBreadcrumbClick(breadcrumb.path)}
                  className="text-muted-foreground hover:text-foreground transition-colors duration-150 hover:underline"
                >
                  {breadcrumb.label}
                </button>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </nav>
  );
};

export default BreadcrumbNavigation;